import _implicitStylesheets from "./handler.css";
import _implicitScopedStylesheets from "./handler.scoped.css?scoped=true";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = [];
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, s: api_slot} = $api;
  const {_m0} = $ctx;
  return [api_slot("", {
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.onAnalyticsEvent))
    }
  }, stc0, $slotset)];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = [""];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-20vebhkg2hu";
tmpl.legacyStylesheetToken = "undefined-_handler";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
